import styled, { css } from 'styled-components';

import { InputCheck, PasswordField } from '@speeki/global-ui-components';

export const FullPasswordField = styled(PasswordField)`
    width: 100%;
`;

export const PasswordCheck = styled(InputCheck)<{ isOpen: boolean }>(
    ({ isOpen }) => css`
        ${isOpen && `margin-top: 8px;`}
    `,
);
